import { render, staticRenderFns } from "./GalleryBig6.vue?vue&type=template&id=024413ce&scoped=true&"
import script from "./GalleryBig6.vue?vue&type=script&lang=js&"
export * from "./GalleryBig6.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig6.vue?vue&type=style&index=0&id=024413ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024413ce",
  null
  
)

export default component.exports